// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"ModalSubtitle_subtitle__2AB9y"};